const $ = require('jquery');
const WS = require('../../scripts/ws');
const _throttle = require('lodash/throttle');

$(function () {
    if (!WS.isExperienceEditor()) {
        let $window = $(window),
            $persistentCta = $(".ws-cta-persistent"),
            $cookieBanner = $("#ws-banner-cookie-notification"),
            isCookieNotificationVisible = $cookieBanner.is(":visible");

        // Function to update CTA position
        function updateCtaPosition() {
            if ($cookieBanner.is(":visible")) {
                const bannerRect = $cookieBanner[0].getBoundingClientRect();
                const bannerHeight = bannerRect.height || 0;
                $persistentCta.css('bottom', (bannerHeight) + 'px');
            } else {
                $persistentCta.css('bottom', '0px');
            }
        }

        // Initial position
        updateCtaPosition();

        // Update on window resize or if banner visibility changes
        $window.on('resize', _throttle(updateCtaPosition, 50));

        // If the banner might appear/disappear dynamically, observe changes
        const observer = new MutationObserver(updateCtaPosition);
        if ($cookieBanner.length) {
            observer.observe($cookieBanner[0], { attributes: true, attributeFilter: ['style', 'class'] });
        }

        if (!isCookieNotificationVisible) {
            $persistentCta.addClass("ws-cta-persistent--no-cookie-banner");
        }

        // Throttled scroll handler to toggle visibility of the persistent CTA based on scroll depth
        let persistentCtaScrollHandler = _throttle(function () {
            const scrollDepth = $persistentCta.data('scroll-depth') || 700;
            if (window.scrollY > scrollDepth) {
                $persistentCta.addClass("ws-cta-persistent--visible");
            }
            else {
                $persistentCta.removeClass("ws-cta-persistent--visible");
            }
        }, 200);

        $window.on("scroll", persistentCtaScrollHandler);
    }
});